import React from 'react';
import { StyleSheet, Text, View, TouchableOpacity } from 'react-native';
import { defaultScale } from '../../utils';
import { ChevronRightIcon } from './Icons';
import Theme from '../../theme';

export const JoinOrCheckinWorkoutButton
  = ({ actionText, t, onPress, timeRemaining, hasFirstExerciseStarted, containerStyles }) => (
  <TouchableOpacity
    style={[styles.buttonContainer, { backgroundColor: Theme.PRIMARY }, containerStyles]}
    onPress={onPress}
  >
    <Text style={styles.buttonText}>{
      hasFirstExerciseStarted ? t('classHasStarted') : t('classStartsIn', { timeRemaining })}
    </Text>
    <Text style={styles.line}> | </Text>
    <Text style={[styles.buttonText ]}>
      {actionText}
    </Text>
    <View style={styles.arrowContainer}>
      <View style={styles.arrowIcon}>
        <ChevronRightIcon width={defaultScale(18)} height={defaultScale(18)} color={Theme.WHITE}/>
      </View>
    </View>
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  buttonContainer: {
    height: defaultScale(50),
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  buttonText: {
    ...Theme.textStyle.heading2,
    color: Theme.WHITE,
  },
  line: {
    color: Theme.WHITE,
    fontSize: 35,
    fontFamily: Theme.Custom200,
  },
  arrowContainer: {
    flexDirection: 'row',
    paddingVertical: 15,
    alignItems: 'center',
  },
  arrowIcon: {
    width: 25,
    paddingHorizontal: 5,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
